























































import { AvisDePrelevement } from "../../models/AvisDePrelevement";

export default {
    name: "AvisDePrelevementModalDisplay",
    props: {
        avisDePrelevement: AvisDePrelevement
    },
    methods: {
        roundAmount(amount) {
            return _.round(amount || 0, 2).toFixed(2);
        },
    },
};
